import { palette } from "../palette";
import { customShadows } from "../custom-shadows";

// ----------------------------------------------------------------------

export function contrast(contrastBold, mode) {
  const theme = {
    ...(contrastBold &&
      mode === "light" && {
        palette: {
          background: {
            // grey[200] ya es el background.default de marca: baja un paso más
            default: palette(mode).grey[300],
          },
        },
      }),
  };

  const components = {
    ...(contrastBold && {
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: customShadows(mode).z4,
          },
        },
      },
    }),
  };

  return {
    theme,
    components,
  };
}
